const colors = {
  primary: "#d7d7d7",
  primaryLight: "#ececec",
  primaryDark: "#a4a4a4",
  secondary: "#4690fe",
  secondaryLight: "#84c0ff",
  secondaryDark: "#0063ca",
  grey: "#d7d7d7",
  darkGrey: "#a4a4a4",
  lightGrey: "#ececec",
  red: "#b00020",
  blue: "#4690fe",
  border: "rgba(0,0,0,0.2)",
  yellow: "#c79a00",
  green: "#388e3c"
};

export default {
  colors,
  overlay: "rgba(0, 0, 0, 0.5)",
  background: "#FFFFFF",
  border: colors.border,
  folder: colors.yellow,
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.60)",
    primaryInverted: "rgba(255, 255, 255, 0.87)",
    secondaryInverted: "rgba(255, 255, 255, 0.60)",
    disabled: "rgba(0, 0, 0, 0.38)",
    error: colors.red
  },
  scrollBar: {
    background: "#f1f1f1",
    track: "#f1f1f1",
    thumb: "#c1c1c1",
    thumbHover: "#d2d2d2"
  },
  topBar: {
    background: colors.primary,
    title: "rgba(0, 0, 0, 0.40)",
    tab: {
      backgroundActive: "white",
      backgroundInactive: "#9e9e9e",
      borderColor: "#838383",
      selectedTabAccent: colors.secondary
    },
    active: "white",
    inactive: colors.primaryDark
  },
  input: {
    background: "white",
    backgroundDisabled: "rgb(243, 243, 243)",
    border: "#a9a9a9",
    text: "rgba(0, 0, 0, 0.87)"
  },
  controlBar: {
    background: colors.primaryLight
  },
  assetList: {
    thumbnail: {
      border: colors.border,
      hover: "white"
    },
    pagination: {
      background: colors.primary,
      active: colors.secondary,
      hover: "rgba(255, 255, 255, 0.2)",
      border: colors.border
    }
  },
  sideBar: {
    background: "#acacac",
    tab: {
      backgroundActive: colors.secondary,
      backgroundHover: colors.primaryLight,
      background: "#acacac",
      backgroundDisabled: "#acacac"
    }
  },
  footer: {
    background: colors.primary
  },
  button: {
    hoverOverlay: "rgba(255, 255, 255, 0.3)",
    clickOverlay: "rgba(255, 255, 255, 0.9)",
    standard: {
      background: colors.primaryLight
    },
    outlined: {
      border: colors.border
    },
    text: {},
    icon: {
      color: "rgba(0, 0, 0, 0.60)"
    },
    close: {
      hover: "#e81123",
      active: "#b50d1b"
    }
  },
  table: {
    header: "#b9cbe2",
    background: "#d7d6d6",
    selectedRow: colors.secondary,
    row: colors.primaryLight,
    border: "rgba(0,0,0,0.2)"
  },
  editor: {
    header: colors.primaryDark,
    replaceableImage: {
      background: "#c1c1c1",
      borderSelected: "#fefefe",
      boxShadow: colors.secondary
    }
  },
  savedItems: {
    globalCategory: colors.primaryDark,
    userCategory: colors.secondaryDark,
    menuBackground: colors.primary
  },
  modal: {
    background: "white",
    header: "#5379a2",
    headerText: "rgba(255, 255, 255, 0.87)"
  },
  snackBar: {
    background: "#323232",
    buttonHover: "rgba(255,255,255,0.6)",
    buttonActive: "rgba(255,255,255,0.9)"
  }
};



// WEBPACK FOOTER //
// ./app/themes/standard.js